import { useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import { shallow } from 'zustand/shallow'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

const ViewModel = () => {
  const navigate = useNavigate()
  const { id: projectId, pileHoleId } = useParams()
  const { data, getData, clearState } = useProjectStore(
    state => ({
      data: state.pileHole,
      getData: state.getPileHoleInfo,
      clearState: state.clearState,
    }),
    shallow
  )
  const pics = useMemo(() => {
      return data?.gallery ?? [] 
  }, [data, pileHoleId])


  const fetchData = () => {
    if (projectId && pileHoleId) {
      getData(parseInt(projectId),parseInt(pileHoleId)).then(({ success, data }) => {
        if (!success) {
          toast.error(`Fetch data failed : ${data}`)
        }
      })
    } else {
      Swal.fire({
        icon: 'error',
        text: 'Project ID is not found',
      }).then(({ isConfirmed }) => {
        if (isConfirmed) {
          navigate('/project')
        }
      })
    }
  }

  useEffect(() => {
    fetchData()

    return () => {
      clearState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId])

  return {
    pics,
  }
}

export default ViewModel
